import script from "./ProdutoRotuloSolicitacaoDetalhe_29.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoRotuloSolicitacaoDetalhe_29.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoRotuloSolicitacaoDetalhe_29.vue?vue&type=style&index=0&id=f4dbb2da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4dbb2da"]])

export default __exports__